import { VerifyTotpForm } from "@/features/sign-in/components/verify-totp.form";

export function VerifyTotp() {
  return (
    <div>
      <div className="px-4 sm:px-6">
        <p className="text-lg font-medium text-foreground">
          Two-step verification
        </p>
        <p className="text-base font-normal text-muted">
          To continue, please enter the verification code generated by your
          authenticator app
        </p>
        <div className="my-8 sm:my-11">
          <VerifyTotpForm />
        </div>
      </div>
    </div>
  );
}
